import { useQuery } from '@apollo/client';
import { getEntitySchemaQuery } from '../../graphql/queries';

const getEntityActions = entity => {
  const { loading, error, data } = useQuery(getEntitySchemaQuery(), {
    variables: { identifier: entity }
  });
  if (loading || error || !data.entitySchema || !data.entitySchema[0].actions) return null;

  return data.entitySchema[0].actions;
};

export default getEntityActions;
